// Brand-specific Scayle pricePromotionKey.
// Read by layers/base/constants/withParameters.ts via the consumer-app `~/` alias.
export const DEFAULT_PRICE_PROMOTION_KEY = '99990000'
